import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import { useMemo } from 'react';
import { useWithConfirmDialog } from '../../confirmDialogs';
import { useEvent } from '../../hooks';
import { omitDefaultValues, sameValuesEntries, toModificatoins } from './helpers';
const CONFIRM_DIALOG_THRESHOLD = 10;
export function useHandleOk(handler, options) {
    const { selectedRows, totalRows, visibleColumns } = options;
    const selectionCount = selectedRows.length;
    const shouldShowConfirmDialog = selectionCount === 0 || selectionCount > CONFIRM_DIALOG_THRESHOLD;
    const withConfirmDialog = useWithConfirmDialog();
    const defaultValues = useMemo(() => sameValuesEntries(selectedRows), [selectedRows]);
    const toModificationsWithColumns = useMemo(() => toModificatoins(visibleColumns), [visibleColumns]);
    const handleData = (values) => {
        const omitted = omitDefaultValues(defaultValues, values);
        const modifications = toModificationsWithColumns(omitted);
        return handler(modifications);
    };
    const handleDataWithConfirm = (data) => withConfirmDialog({
        title: (_jsx(FormattedMessage, { id: "batchEditDialog.confirm_title_edit_n", defaultMessage: "Do you want to apply the changes to {n} rows", values: { n: selectionCount === 0 ? totalRows : selectionCount } })),
        onConfirm: () => handleData(data),
    })();
    return useEvent(shouldShowConfirmDialog ? handleDataWithConfirm : handleData);
}
//# sourceMappingURL=useHandleOk.js.map